import { FiX } from "solid-icons/fi";
import { Empty } from '@biketravel/solid-ui';

export const TrackEmpty = () => (
  <Empty
    icon={<FiX stroke-width={1}/>}
    title='Маршруты не найдены'
    text='По выбранным параметрам маршруты не найдены или отсутствуют'
  />
)